import React, { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const AddCommentModal = ({ show, handleClose, handleAdd, taskComment, dates }) => {
  const [comment, setComment] = React.useState(taskComment);

  // const placeholder = dates?.length
  //   ? dates.map((date) => `[${date}] details ...`).join("\n")
  //   : "Type here";

  const onAdd = () => {
    handleAdd(comment);
  };

  const onCancel = () => {
    handleClose();
    setComment('');
    
  };

  // useEffect(() => {
  //   setComment(taskComment || "");
  // }, [taskComment]);


  useEffect(() => {
    if (show) {
      setComment(taskComment || "");
    } else {
      setComment("");
    }
  }, [show, taskComment]);

  
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="add-comment-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h2 className="font-16 font-weight-bold heading-color mb-0">Add Comment</h2>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Comment</Form.Label>
            <Form.Control
              as="textarea"
              placeholder='Type Here'
              style={{
                borderRadius: "10px",
                height: "120px",
                border: "1px solid rgb(206, 212, 218)",
                padding: "4px 12px",
                fontSize: "12px",
                fontWeight: 400,
                color: "rgb(97, 121, 115)",
              }}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className=" d-inline align-items-center justify-content-center">
        <div className="d-flex align-items-center gap-3">
            <button
          variant="none"
          onClick={handleClose}
          className="c-b-btn w-100"
        >
          Cancel
        </button>
        <button
          variant="none"
          onClick={onAdd}
         className="add-new-btn w-100"
        >
          Add
        </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCommentModal;
